<template>
  <div id="otherSet">
    <el-row>
      <el-col :span="24" class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>第三方参数设置</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true" class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID" filterable clearable placeholder="请选择客户">
            <el-option v-for="item in choiceCusts" :key="item.fCustID" :label="item.unionName" :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场库名称::">
          <el-input placeholder="请输入场库名称" v-model="bindQueryInput" class="input-with-select">
            <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
          </el-input>
        </el-form-item>
        <el-form-item label="场库编号::">
          <el-input placeholder="请输入场库编号" v-model="bindQueryfParkNo" class="input-with-select">
            <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" @click="bindQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24" style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="parkList" border highlight-current-row v-loading="loading" style="width: 100%"
        :height="tableHeight" ref="singleTable">
        <el-table-column type="index" width="50" label="序号" :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fOpLastTimeName" width="180" label="最后同步时间">
        </el-table-column>
        <el-table-column prop="fCustNo" width="80" label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName" width="160" label="客户名称">
        </el-table-column>
        <el-table-column prop="fParkNo" width="80" label="场库编号">
        </el-table-column>
        <el-table-column prop="fParkName" width="160" label="场库名称">
        </el-table-column>
        <el-table-column prop="fParkTypeName" width="120" label="场库类型">
        </el-table-column>
        <!-- <el-table-column prop="fInvoiceType"
                          width="100"
                          label="电子发票">
        </el-table-column> -->
        <el-table-column prop="fOtherSetOnlineType" label="第三方设置">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="160">
          <template slot-scope="scope">
            <el-button @click="viewPark(scope.row)" type="success" size="mini">查看</el-button>
            <el-button size="mini" type="warning" v-if="is_edit"
              @click="editParkClient(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background @size-change="handleSizeChange" :current-page.sync="pageIndex"
            @current-change="handlePage" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes, prev, pager, next, jumper" :total="total" v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="parkPayEditOrDetail">
      <el-dialog :title="detailTitle" :visible.sync="parkEditOrDetailVisible" v-dialogDrag top="7vh" left="0vh"
        width="60%">
        <el-form :inline="true" label-width="100px">
          <el-tabs v-model="editOrDetail" tab-position="left" type="card" @tab-click="tab_click">
            <el-tab-pane name="editBaseInfo">
              <span slot="label"><i class="el-icon-check" v-if="(cubeInfoObject.p10005 == '1')"></i>Cube</span>
              <fieldset>
                <legend style="padding-top: 10px">Cube设置</legend>
                <el-form :inline="true" label-width="120px">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="门岗进出推送url::">
                        <el-input v-model="cubeInfoObject.p10001" style="width:800px" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="说明::">
                        <label  style="width:800px" disabled="true" class="myParkInput">门岗进出推送客户编号和场库编号必须填写(例如:Upload/CubePayInfos?fCustNo=510200&fParkNo=200510)</label>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="门岗缴费推送url::">
                        <el-input v-model="cubeInfoObject.p10002" style="width:800px" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="说明::">
                        <label  style="width:800px" disabled="true" class="myParkInput">门岗缴费推送客户编号和场库编号必须填写(例如:Upload/CubePayInfos?fCustNo=510200&fParkNo=200510)</label>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="iot推送进出url::">
                        <el-input v-model="cubeInfoObject.p10003" style="width:800px" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="余位信息url::">
                        <el-input v-model="cubeInfoObject.p10004" style="width:800px" :disabled="!isEdit"
                          class="myParkInput"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="启用状态::">
                        <el-radio-group v-model="cubeInfoObject.p10005" :disabled="!isEdit"
                          @change="changeEnable($event, 1, '')">
                          <el-radio label="0">禁用</el-radio>
                          <el-radio label="1">启用</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </fieldset>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <el-row style="margin-top:-1px">
          <el-col :span="12">
            <div class="tab_foot">&nbsp;</div>
            <div class="btn_foot">
            </div>
          </el-col>
          <el-col :span="12">
            <div class="dialog-footer">
              <el-button type="primary" @click="submitForm('form')" v-if="isEdit" :loading="save_loading">{{ save_msg
              }}</el-button>
              <el-button @click="parkEditOrDetailVisible = false">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable*/
//此行往下都不检查Eslint
import { mapActions } from 'vuex'
import $ from 'jquery'
import * as user from '../../api/user'
export default {
  name: 'otherSet',
  data () {
    return {
      flagTemp: false,
      selPayType: [],
      init_loading: false,
      inittwo_loading: false,
      save_loading: false,
      save_msg: '保存',
      loading: false,
      is_edit: false,
      is_export: false,
      is_del: false,
      is_syn: false,
      is_admin: false,
      pay_url: '',
      cubeInfoObject: {
        p10001: '',
        p10002: '',
        p10003: '',
        p10004: '',
        p10005: '0'
      },
      isEdit: false,
      curRowInfo: {},
      tab_height: 0,
      editOrDetail: 'editBaseInfo',
      parkEditOrDetailVisible: false,
      detailTitle: '查看停车场信息',
      parkDetailVisible: false,
      choiceCusts: [],
      bindQueryfParkNo: '',
      bindQueryInput: '',
      selCustID: '',
      parkList: [],
      synParkList: [],
      tableHeight: 0,
      pageSize: 20,
      pageIndex: 1,
      total: 0
    }
  },
  methods: {
    ...mapActions([
      'getParkOtherSetByCurrUser', 'getParkPayParams', 'getCustByGroup', 'getAllParkParamByParkId', 'getMapAndParkType', 'getRateGroupByCustId', 'saveParkPay',
      'deletePark', 'synParkById', 'getCurrentUserPers', 'getPayUrl', 'getAllParkOtherSetParam', 'saveParkOtherSet'
    ]),
    changeEnable (val, type, typeName) {
      if (val === '1') {
        switch (type) {
          case 1: // 立方 , 关闭其他
            //this.cubeInfoObject.p10005 = '0'
            break
          case 2:
            //this.cubeInfoObject.p73050 = '0'
            break
        }
      }
    },
    submitForm (formName) {
      let param = {}
      param.curRowInfo = this.curRowInfo
      param.cubeInfoObject = this.cubeInfoObject
      this.save_loading = true
      this.save_msg = '保存中…'
      this.saveParkOtherSet(param).then(res => {
        this.save_loading = false
        this.save_msg = '保存'
        if (res && res.data) {
          1

          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.initData()
              this.parkEditOrDetailVisible = false
              this.$message({
                type: 'success',
                message: data.Msg
              })
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    setDefault () {
      for (let key in this.cubeInfoObject) {
        this.cubeInfoObject[key] = ''
      }
      this.cubeInfoObject.p10005 = '0'
      this.cubeInfoObject.p10002 = 'http://transdata.shangjieiot.com:8089/'
      this.cubeInfoObject.p10001 = 'http://transdata.shangjieiot.com:8089/'

    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageIndex = index
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageIndex - 1) + index + 1
    },
    bindQuery () {
      this.initData()
    },
    tab_click (tab) {
      this.setTabHeight($('#' + tab.$el.id).height())
    },
    setTabHeight (contentHeight) {
      var height = $('.parkPayEditOrDetail .el-tabs__content:eq(0)').height()
      if (this.tab_height <= 0) {
        this.tab_height = $('.parkPayEditOrDetail .el-tabs__nav-scroll:eq(0)').height()
      }
      if (contentHeight) {
        $('.parkPayEditOrDetail .el-tabs__nav-scroll:eq(0)').css('height', (this.tab_height > contentHeight ? this.tab_height : contentHeight) + 'px')
      } else {
        $('.parkPayEditOrDetail .el-tabs__nav-scroll:eq(0)').css('height', (height > this.tab_height ? height : this.tab_height) + 'px')
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    updatePark (row, isEdit, op) {
      this.setDefault()
      let curRow = {}
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.isEdit = isEdit
      this.curRowInfo.op = op
      this.detailTitle = '【' + row.fCustName + '(' + row.fCustNo + ')' + '-' + row.fParkName + '】' + (isEdit ? '编辑场库第三方设置' : '查看场库第三方设置')
      this.parkEditOrDetailVisible = true

      setTimeout(() => {
        this.setTabHeight()
      }, 100)
      this.getAllParkOtherSetParam({ fIsPay: true, fCustID: row.fCustID, fParkID: row.fParkID, fIsSyn: false }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              Object.assign(this.cubeInfoObject, data.Data.cubeInfoObject)
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    viewPark (row) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePark(row, false, 'view')
      }
    },
    editParkClient (index, row) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePark(row, true, 'edit')
      }
    },
    initData () {
      let param = {}
      param['fCustID'] = this.selCustID
      param['fParkName'] = this.bindQueryInput.trim()
      param['fParkNo'] = this.bindQueryfParkNo.trim()
      param.pageSize = this.pageSize
      param.pageIndex = this.pageIndex
      this.parkList = []
      this.loading = true
      this.getParkOtherSetByCurrUser(param).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parkList = data.Data.data || []
              this.total = data.Data.count
            }
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 1283000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
            this.is_admin = data.Data.is_admin
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
    user.initConfig().then((res) => {
      let { data } = res
      if (data.IsOk) {
        this.pay_url = data.Data.payUrl
      }
    })
  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.changeCust(this.selCustID)
            }
          }
        }
      }
    })
    //this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
.parkPayEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}

.parkPayEditOrDetail .el-dialog__title {
  color: white;
}

.parkPayEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}

.parkPayEditOrDetail .el-dialog__body {
  padding: 0px;
}

.parkPayEditOrDetail .myParkInput {
  width: 220px;
}

.parkPayEditOrDetail .el-row {
  margin-top: 5px;
}

.parkPayEditOrDetail .el-radio {
  line-height: 2px;
}

.parkPayEditOrDetail .is-disabled .el-input__inner,
.parkPayEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}

/* tab 样式 */
.parkPayEditOrDetail .el-tabs__item {
  padding: 0px 20px 0px 0px;
}

.parkPayEditOrDetail .el-tabs__nav-scroll {
  background-color: #ccc;
  text-align: center;
  width: 110px;
  overflow: auto;
}

.parkPayEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__nav>.el-tabs__item {
  text-align: right;
}

.parkPayEditOrDetail .el-tabs__nav-next,
.parkPayEditOrDetail .el-tabs__nav-prev {
  display: none;
}

.parkPayEditOrDetail .el-tabs__nav-wrap.is-scrollable {
  padding: 0px !important;
}

.parkPayEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  border: none !important;
}

.parkPayEditOrDetail .el-tabs__item:hover {
  color: white;
  background-color: #409eff;
}

.parkPayEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__nav {
  border-bottom: none;
}

.parkPayEditOrDetail .el-tabs__nav {
  margin-top: -1px;
  margin-left: -1px;
}

.parkPayEditOrDetail .el-tabs--left .el-tabs__header.is-left {
  margin-right: 0px;
}

.parkPayEditOrDetail .fRemark_row .el-form-item__content {
  height: 60px !important;
}

.parkPayEditOrDetail .parkTextArea .el-textarea__inner {
  width: 800px;
  height: 60px !important;
}

.parkPayEditOrDetail .interfaceAPI {
  width: 550px;
}

.parkPayEditOrDetail .fRemark_bigrow .el-form-item__content {
  height: 200px !important;
}

.parkPayEditOrDetail .parkBigTextArea .el-textarea__inner {
  width: 800px;
  height: 200px !important;
}

.parkPayEditOrDetail .child_card .el-tabs__nav-scroll {
  width: 100%;
}

.parkPayEditOrDetail .child_card .el-tabs__item {
  padding: 0px 20px;
  text-align: center !important;
}

#otherSet .warning-row {
  color: chocolate;
}

#otherSet .el-dialog {
  min-width: 1100px;
}
</style>
<style scoped>
fieldset {
  padding-bottom: 0px;
}

.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}

#parkBaiduMap {
  float: left;
}

.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}

.search_list {
  height: 300px;
  width: 300px;
  overflow-y: auto;
  float: left;
}

.search_list .el-row {
  margin-top: 0px;
}

.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}

.parkMain_BaseInfo .el-select {
  width: 100%;
}

.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}

.pageSearch .el-form-item {
  margin-bottom: 5px;
}

.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}

.myel-input__inner {
  height: 20px;
  line-height: 20px;
}

legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}

fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}

.trans_row {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}

.tab_foot {
  float: left;
  width: 110px;
  height: 80px;
  background: #ccc;
}

.btn_foot {
  float: left;
  text-align: right;
  padding: 20px;
}

.dialog-footer {
  text-align: right;
  padding: 20px;
}

.ICBCPay_tip {
  padding: 8px 16px;
  background-color: #ecf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  overflow: hidden;
  margin-top: 15px;
}

.ICBCPay_tip div {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/view/park/otherSet.vue